import { AppStage } from '../frontendConfig';
import { ThemeConfig } from './themeConfig';
import { ThemePath } from './themes';

export type ThemeConfigByPath = Record<ThemePath, Partial<ThemeConfig>>;

export type ThemeConfigOverride = Record<AppStage, ThemeConfigByPath>;

export const ThemeConfigOverrides: Partial<ThemeConfigOverride> = {
  development: {
    alpha: {
      stockbrokingPlatformUrl: `https://hdev-www.cmcmarketsstockbroking.com.au`
    },
    asb: {
      stockbrokingPlatformUrl: `https://hdev-www.cmcmarketsstockbroking.com.au`
    },
    au: {
      onboardingUrl: 'https://790.ui.onboarding.sb.nonprod.aws.cmclabs.io/au/select-account-type',
      stockbrokingPlatformUrl: `https://hdev-www.cmcmarketsstockbroking.com.au`
    },
    bendigo: {
      stockbrokingPlatformUrl: 'https://hdev-trading.bendigoinvestdirect.com.au'
    },
    ebroking: {
      stockbrokingPlatformUrl: 'https://hdev-www.cmcmarketsstockbroking.com.au/ebroking'
    },
    partners: {
      stockbrokingPlatformUrl: 'https://hdev-www.cmcmarketsstockbroking.com.au/partners'
    },
    rivkin: {
      stockbrokingPlatformUrl: 'https://hdev-www.cmcmarketsstockbroking.com.au/rivkin'
    },
    sg: {
      onboardingUrl: 'https://790.ui.onboarding.sb.nonprod.aws.cmclabs.io/sg/create-log-in',
      stockbrokingPlatformUrl: `https://hdev-www.cmcmarketsstockbroking.com.au`
    },
    stgeorge: {
      stockbrokingPlatformUrl: 'https://hdev-trading.directshares.com.au'
    },
    westpac: {
      stockbrokingPlatformUrl: 'https://hdev-www.cmcmarketsstockbroking.com.au'
    }
  },
  staging: {
    alpha: {
      stockbrokingPlatformUrl: `https://uat-www.cmcmarketsstockbroking.com.au`
    },
    asb: {
      stockbrokingPlatformUrl: `https://uat-www.cmcmarketsstockbroking.com.au`
    },
    au: {
      onboardingUrl: 'https://staging-signup.nonprod-invest.cmcmarkets.com.au/au/select-account-type',
      stockbrokingPlatformUrl: `https://uat-www.cmcmarketsstockbroking.com.au`
    },
    bendigo: {
      stockbrokingPlatformUrl: 'https://uat-trading.bendigoinvestdirect.com.au'
    },
    ebroking: {
      stockbrokingPlatformUrl: 'https://uat-www.cmcmarketsstockbroking.com.au/ebroking'
    },
    partners: {
      stockbrokingPlatformUrl: 'https://uat-www.cmcmarketsstockbroking.com.au/partners'
    },
    rivkin: {
      stockbrokingPlatformUrl: 'https://uat-www.cmcmarketsstockbroking.com.au/rivkin'
    },
    sg: {
      onboardingUrl: ' https://staging-signup.nonprod-invest.cmcmarkets.com.au/sg/create-log-in',
      stockbrokingPlatformUrl: `https://uat-www.cmcmarketsstockbroking.com.au`
    },
    stgeorge: {
      stockbrokingPlatformUrl: 'https://uat-trading.directshares.com.au'
    },
    westpac: {
      stockbrokingPlatformUrl: 'https://uat-www.cmcmarketsstockbroking.com.au'
    }
  },
  sit: {
    alpha: {
      stockbrokingPlatformUrl: `https://hdev4-www.cmcmarketsstockbroking.com.au`
    },
    asb: {
      stockbrokingPlatformUrl: `https://hdev4-www.cmcmarketsstockbroking.com.au`
    },
    au: {
      stockbrokingPlatformUrl: `https://hdev4-www.cmcmarketsstockbroking.com.au`
    },
    bendigo: {
      stockbrokingPlatformUrl: `https://hdev4-www.bendigoinvestdirect.com.au`
    },
    ebroking: {
      stockbrokingPlatformUrl: `https://hdev4-www.cmcmarketsstockbroking.com.au/ebroking`
    },
    partners: {
      stockbrokingPlatformUrl: `https://hdev4-www.cmcmarketsstockbroking.com.au/partners`
    },
    rivkin: {
      stockbrokingPlatformUrl: `https://hdev4-www.cmcmarketsstockbroking.com.au/rivkin`
    },
    sg: {
      stockbrokingPlatformUrl: `https://hdev4-www.cmcmarketsstockbroking.com.au`
    },
    stgeorge: {
      stockbrokingPlatformUrl: `https://hdev4-www.directshares.com.au`
    },
    westpac: {
      stockbrokingPlatformUrl: `https://hdev4-www.cmcmarketsstockbroking.com.au`
    }
  },
  nfr: {
    alpha: {
      stockbrokingPlatformUrl: `https://nfr-www.cmcmarketsstockbroking.com.au`
    },
    asb: {
      stockbrokingPlatformUrl: `https://nfr-www.cmcmarketsstockbroking.com.au`
    },
    au: {
      stockbrokingPlatformUrl: `https://nfr-www.cmcmarketsstockbroking.com.au`
    },
    bendigo: {
      stockbrokingPlatformUrl: `https://nfr-trading.bendigoinvestdirect.com.au`
    },
    ebroking: {
      stockbrokingPlatformUrl: `https://nfr-www.cmcmarketsstockbroking.com.au/ebroking`
    },
    partners: {
      stockbrokingPlatformUrl: `https://nfr-www.cmcmarketsstockbroking.com.au/partners`
    },
    rivkin: {
      stockbrokingPlatformUrl: `https://nfr-www.cmcmarketsstockbroking.com.au/rivkin`
    },
    sg: {
      stockbrokingPlatformUrl: `https://nfr-www.cmcmarketsstockbroking.com.au`
    },
    stgeorge: {
      stockbrokingPlatformUrl: `https://nfr-trading.directshares.com.au`
    },
    westpac: {
      stockbrokingPlatformUrl: `https://nfr-www.cmcmarketsstockbroking.com.au`
    }
  },
  production: {
    alpha: {
      stockbrokingPlatformUrl: `https://www.cmcmarketsstockbroking.com.au`
    },
    asb: {
      stockbrokingPlatformUrl: `https://www.cmcmarketsstockbroking.com.au`
    },
    au: {
      stockbrokingPlatformUrl: `https://www.cmcmarketsstockbroking.com.au`
    },
    bendigo: {
      stockbrokingPlatformUrl: `https://trading.bendigoinvestdirect.com.au`
    },
    ebroking: {
      stockbrokingPlatformUrl: `https://www.cmcmarketsstockbroking.com.au/ebroking`
    },
    partners: {
      stockbrokingPlatformUrl: `https://www.cmcmarketsstockbroking.com.au/partners`
    },
    rivkin: {
      stockbrokingPlatformUrl: `https://www.cmcmarketsstockbroking.com.au/rivkin`
    },
    sg: {
      stockbrokingPlatformUrl: `https://www.cmcmarketsstockbroking.com.au`
    },
    stgeorge: {
      stockbrokingPlatformUrl: `https://trading.directshares.com.au`
    },
    westpac: {
      stockbrokingPlatformUrl: `https://www.cmcmarketsstockbroking.com.au`
    }
  }
};

export const getOverriddenThemeConfig = (themeConfig: ThemeConfig, environment: AppStage): ThemeConfig => {
  const themePathOverrides = ThemeConfigOverrides[environment]?.[themeConfig.themePath];
  return themePathOverrides ? { ...themeConfig, ...themePathOverrides } : themeConfig;
};
